import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_DISPATCHES':
    case 'REQUEST_DRIVER_DISPATCHES':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_DISPATCHES':
      return Object.assign({}, state, {
        dispatchList: action.payload.data,
        loading: action.loading
      })
    case 'CREATE_DISPATCH':
      const newDispatchList = [{ ...action.payload.newDispatch }, ...state.dispatchList]
      return Object.assign({}, state, {
        dispatchList: newDispatchList,
        loading: action.loading
      })
    case 'EDIT_DISPATCH':
      const updatedSiteIndex = state.dispatchList.findIndex(
        dispatch => dispatch._id === action.payload.dispatch._id
      )
      return Object.assign({}, state, {
        dispatchList: [
          ...state.dispatchList.slice(0, updatedSiteIndex),
          { ...action.payload.dispatch },
          ...state.dispatchList.slice(updatedSiteIndex + 1)
        ],
        loading: action.loading
      })
    case 'RECEIVE_DRIVER_DISPATCHES':
      return Object.assign({}, state, {
        driverDispatchList: action.payload.data,
        loading: action.loading
      })
    case 'CANCEL_DRIVER_DISPATCH':
      const dispatchListDrivers = state.driverDispatchList.filter(
        item => item._id !== action.payload.cancelledDriverId
      )
      return Object.assign({}, state, {
        driverDispatchList: dispatchListDrivers,
        loading: action.loading
      })
    case 'CANCEL_DISPATCH':
      const dispatchList = state.dispatchList
      const dispatchIndex = state.driverDispatchList.findIndex(
        item => item._id === action.payload.cancelledDispatchId
      )
      dispatchList[dispatchIndex]['status'] = 'cancelled'
      return Object.assign({}, state, {
        dispatchList: dispatchList,
        loading: action.loading
      })
    default:
      return state
  }
}

export default reducer
